<template>
  <div class="container-fluid admin-top">
    <div class="sidenav">
      <div class="component-box">
        <div class="box-header-bar">
          管理画面
        </div>
        <div class="box-contents">
          <div class="box-row">
            <div :class="{ selected: routeName === 'AdminGroups2' }">
              <router-link :to="{ name: 'AdminGroups2' }" class="nav-link">
                事業所管理
              </router-link>
            </div>
          </div>
          <div class="box-row">
            <div :class="{ selected: routeName === 'AdminGroups3' }">
              <router-link :to="{name: 'AdminGroups3' }" class="nav-link">
                部署管理
              </router-link>
            </div>
          </div>
          <div class="box-row">
            <div :class="{ selected: routeName === 'AdminUsers' }">
              <router-link :to="{ name: 'AdminUsers' }" class="nav-link">
                ユーザー管理
              </router-link>
            </div>
          </div>
          <div class="box-row">
            <div :class="{ selected: routeName === 'AdminDevices' }">
              <router-link :to="{ name: 'AdminDevices' }" class="nav-link">
                車載器管理
              </router-link>
            </div>
          </div>
          <div class="box-row" v-if="hasRoleOperationsAdmin">
            <div :class="{ selected: routeName === 'AdminMovieGroups' }">
              <router-link :to="{ name: 'AdminMovieGroups' }" class="nav-link">
                動画管理
              </router-link>
            </div>
          </div>
          <div class="box-row" v-if="hasRoleOperationsAdmin">
            <div :class="{ selected: routeName === 'AdminTags' }">
              <router-link :to="{ name: 'AdminTags' }" class="nav-link">
                動画タグ管理
              </router-link>
            </div>
          </div>
          <div class="box-row" v-if="hasRoleOperationsAdmin">
            <div :class="{ selected: routeName === 'AdminComments' }">
              <router-link :to="{ name: 'AdminComments' }" class="nav-link">
                付箋管理
              </router-link>
            </div>
          </div>
          <div class="box-row" v-if="hasRoleOperationsAdmin">
            <div :class="{ selected: routeName === 'AdminCommentTypes' }">
              <router-link :to="{ name: 'AdminCommentTypes' }" class="nav-link">
                付箋種別管理
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LoadWaitSpinner v-if="showFullScreenSpinner">
      <template v-slot:message>
        <div v-if="spinnerMessage">
          <p v-if="isHtmlSpinnerMessage" v-html="spinnerMessage" />
          <p v-else>{{spinnerMessage}}</p>
        </div>
      </template>
    </LoadWaitSpinner>
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAuth } from 'src/composables/useAuth';
import { useFullScreenSpinner } from 'src/composables/useFullScreenSpinner';

const spinner = useFullScreenSpinner();
const showFullScreenSpinner = computed(() => spinner.show);
const spinnerMessage = computed(() => spinner.message);
const isHtmlSpinnerMessage = computed(() => spinner.isHtmlMessage);

const route = useRoute();
const routeName = computed(() => route.name);

const { user } = useAuth();
const hasRoleOperationsAdmin = computed(() => user?.hasRoleOperationsAdmin ?? false);
</script>

<style lang="scss" scoped>
.admin-top {
  display: flex;
  padding-top: 15px;
}

.sidenav {
  min-width: 250px;
  .selected {
    color: #158CBA;
    .nav-link:hover {
      background-color: #d3e2eb;
    }
  }
  .nav-link {
    color: inherit;
    &:hover {
      background-color: #fafafa;
    }
  }
}
</style>
